export enum EPackingSlipColumns {
  LINE_NO = 'line',
  PRODUCT_PHOTO = 'photo',
  SKUS = 'sku',
  UPC = 'upc',
  PRODUCTS = 'product',
  DESCRIPTION = 'description',
  BASE_QUANTITY = 'base_quantity',
  BASE_UNIT = 'base_unit',
  ORDERED_QUANTITY = 'ordered_quantity',
  ORDERED_UNIT = 'ordered_unit',
  WAREHOUSE = 'warehouse',
  LOCATION = 'location',
}

export enum EPackingSlipShowKitOptions {
  KIT_COMPONENTS_ONLY = 'KIT_COMPONENTS_ONLY',
  KIT_AND_COMPONENTS = 'KIT_AND_COMPONENTS',
  KIT_PRODUCT_ONLY = 'KIT_PRODUCT_ONLY',
}

export enum EPackingSlipPageSizeOptions {
  A4 = 'A4',
  LETTER = 'LETTER',
  LEGAL = 'LEGAL',
}

export enum EPackingSlipPageOrientationOptions {
  PORTRAIT = 'portrait',
  LANDSCAPE = 'landscape',
}
